import { useMemo } from "react";

export interface ClickUpSourceSettingsText {
  workspaceLabelText: string;
  workspacePlaceholderText: string;
  workspaceHintText: string;
  spaceLabelText: string;
  spacePlaceholderText: string;
  spaceHintText: string;
  folderLabelText: string;
  folderPlaceholderText: string;
  folderHintText: string;
  listLabelText: string;
  listPlaceholderText: string;
  listHintText: string;
  statusesLabelText: string;
  statusesPlaceholderText: string;
  statusesHintText: string;
  doneStatusLabelText: string;
  doneStatusPlaceholderText: string;
  doneStatusHintText: string;
  assignedToMeLabelText: string;
  loadingWorkspacesText: string;
  loadingSpacesText: string;
  loadingFoldersText: string;
  loadingListsText: string;
  loadingStatusesText: string;
  loadErrorText: string;
}

export const useClickUpSourceSettingsText = (
  t: (key: string) => string,
): ClickUpSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.clickup.${key}`);

    return {
      workspaceLabelText: tKey("workspaceLabel"),
      workspacePlaceholderText: tKey("workspacePlaceholder"),
      workspaceHintText: tKey("workspaceHint"),
      spaceLabelText: tKey("spaceLabel"),
      spacePlaceholderText: tKey("spacePlaceholder"),
      spaceHintText: tKey("spaceHint"),
      folderLabelText: tKey("folderLabel"),
      folderPlaceholderText: tKey("folderPlaceholder"),
      folderHintText: tKey("folderHint"),
      listLabelText: tKey("listLabel"),
      listPlaceholderText: tKey("listPlaceholder"),
      listHintText: tKey("listHint"),
      statusesLabelText: tKey("statusesLabel"),
      statusesPlaceholderText: tKey("statusesPlaceholder"),
      statusesHintText: tKey("statusesHint"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      doneStatusHintText: tKey("doneStatusHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      loadingWorkspacesText: tKey("loadingWorkspaces"),
      loadingSpacesText: tKey("loadingSpaces"),
      loadingFoldersText: tKey("loadingFolders"),
      loadingListsText: tKey("loadingLists"),
      loadingStatusesText: tKey("loadingStatuses"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
